<div class="app-container">
    <mat-toolbar class="app-header">
        <button mat-icon-button routerLink="/wells" class="back-button" *ngIf="!isOnWellsPage" title="Back to Wells">
            <mat-icon>arrow_back</mat-icon>
        </button>
        
        <div class="logo">
            <img src="assets/logo.png" alt="Belmont Logo" class="logo-image" />
        </div>

        <span class="app-title">{{ title }}</span>
        <span class="spacer"></span>

        <button mat-button routerLink="/wells" class="nav-button">
            <mat-icon class="header-icon">oil_barrel</mat-icon>
            Wells
        </button>
    </mat-toolbar>

    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>